import React, { useEffect, useState } from "react";
import { useBot } from "../../context/botContext";
import { useAuth } from "../../context/authContext";

// Komponen Ikon Centang (SVG inline)
const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2.5}
    stroke="currentColor"
    className="w-4 h-4 text-white"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const Stepper = ({ currentStep }) => {
  const steps = [
    { id: 0, label: "Connect Wallet" },
    { id: 1, label: "Activate Bot" },
    { id: 2, label: "Start Trading!" },
  ];

  const activeColor = "[#007A78]";
  const inactiveColor = "[#D1D5DB]";
  const innerDotSize = "w-2 h-2 sm:w-2.5 sm:h-2.5";

  return (
    <div className="w-full pt-5 pb-8">
      <div className="flex items-center">
        {steps.map((step, index) => {
          const isCompleted = currentStep > step.id;
          const isActive = currentStep === step.id;
          const isLastStep = index === steps.length - 1;

          let circleBaseClasses = `w-6 h-6 sm:w-7 sm:h-7 rounded-full flex items-center justify-center border-2 transition-all duration-300 ease-in-out relative z-10`;

          let circleSpecificClasses = "";

          if (isActive) {
            circleSpecificClasses = `border-[#007A78] bg-white`;
          } else if (isCompleted) {
            circleSpecificClasses = `bg-[#007A78] border-[#007A78]`;
          } else {
            circleSpecificClasses = `bg-white border-$[#D1D5DB]`;
          }

          let lineElement = null;
          if (!isLastStep) {
            const lineOriginIsActive =
              currentStep > step.id || currentStep === step.id;
            const nextStepIndex = index + 1;
            const nextStepIsInactive =
              nextStepIndex < steps.length &&
              currentStep < steps[nextStepIndex].id;

            let lineBackgroundClass = "";

            if (lineOriginIsActive) {
              if (nextStepIsInactive) {
                lineBackgroundClass = `bg-gradient-to-r from-[#007A78] from-[50%] to-[#D1D5DB] to-[50%]`;
              } else {
                lineBackgroundClass = `bg-[#007A78]`;
              }
            } else {
              lineBackgroundClass = `bg-[#D1D5DB]`;
            }

            lineElement = (
              <div
                className={`flex-1 h-0.5 sm:h-[0.4] duration-300 ease-in-out -mx-px ${lineBackgroundClass}`}
              ></div>
            );
          }

          return (
            <React.Fragment key={step.id}>
              <div className="relative shrink-0">
                <div
                  className={`${circleBaseClasses} ${circleSpecificClasses}`}
                >
                  {isCompleted ? (
                    <CheckIcon />
                  ) : isActive ? (
                    <div
                      className={`${innerDotSize} bg-[#007A78] rounded-full`}
                    ></div>
                  ) : null}
                </div>
                <p
                  className={`absolute top-full left-1/2 -translate-x-1/2 mt-1 text-xs sm:text-sm transition-all duration-300 ease-in-out text-center whitespace-nowrap font-bold text-black ${
                    index === 0 ? "pl-16" : index === 2 ? "pr-16" : ""
                  }`}
                  style={{ minWidth: "75px" }}
                >
                  {step.label}
                </p>
              </div>

              {lineElement}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

// Komponen Halaman Utama (App)
function StepSection({ dashboard, myExchanges }) {
  const { botLists } = useBot();
  const [currentStep, setCurrentStep] = useState(0); // Step awal adalah 0
  const { user } = useAuth();

  useEffect(() => {
    const hasExchange = myExchanges?.length > 0;
    const hasBot = botLists?.length > 0;

    if (hasExchange && hasBot) {
      setCurrentStep(3); // completed all steps
    } else if (hasExchange) {
      setCurrentStep(1);
    } else {
      setCurrentStep(0);
    }
  }, [myExchanges, botLists]);

  return (
    <div className="">
      <div className="mb-3">
        <h5 className="!text-[28px] md:!text-[32px] font-bold capitalize">
          Welcome to your Dashboard, {user?.first_name}!
        </h5>
        {currentStep < 3  && (
          <span className="text-sm md:text-base text-[#21272A]/60">
            Let’s get you started on your trading journey.
          </span>
        )}
      </div>
      {currentStep < 3  && <Stepper currentStep={currentStep} />}
    </div>
  );
}

export default StepSection;
